/**
 *
 * key
 *
 */

 const key = 'b3BlcmF0aW9uc0xldmVsT25l'

 export default key
 